import httpClient from "./httpClient";

const StakeholderService = {
  async findAll(params = {}) {
    return await httpClient.get("/stakeholder", { params });
  },

  async findById(id) {
    return await httpClient.get(`/stakeholder/${id}`);
  },

  async create(entity) {
    return await httpClient.post("/stakeholder", entity);
  },

  async update(id, entity) {
    return await httpClient.put(`/stakeholder/${id}`, entity);
  },

  async delete(id) {
    return await httpClient.delete(`/stakeholder/${id}`);
  }
};

export default StakeholderService;
